import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  accessToken: null,
  authChecked: false,
  loggedOut: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.authChecked = true;
      state.loggedOut = false;
    },

    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.authChecked = true;
      state.loggedOut = true;
    },

    setAuthChecked: (state) => {
      state.authChecked = true;
    },
  },
});

export const { setCredentials, logout, setAuthChecked } = authSlice.actions;

export default authSlice.reducer;
